import { Colors } from '@euler/components/Colors';
import { LinearGradient } from 'expo-linear-gradient';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const VerticalLine = memo(
  ({
    startColor = Colors.White1,
    endColor = Colors.White0_1,
    style,
  }: {
    startColor?: string;
    endColor?: string;
    style?: StyleProp<ViewStyle>;
  }) => {
    return (
      <LinearGradient
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }}
        colors={[endColor, startColor, endColor]}
        locations={[0, 0.5, 1]}
        css={`
          width: 1px;
          flex-shrink: 0;
        `}
        style={style}
      />
    );
  },
);
